import styled from "styled-components";
import {
  screenSize,
  whiteColor,
  inputBackgroundColor,
  inputBorderColor,
  mediumFont,
  inputBackgroundHoverColor,
  primaryColor,
  dangerColor,
  successColor,
  labelColor,
  newsecondaryColor,
} from "@app/styles";

export const InputRowContainer = styled.div`
  margin-bottom: 16px;
`;

export const InputContainer = styled.div`
  position: relative;
  // margin-bottom: 20px;
  &.non-editable {
    cursor: not-allowed;
    &::after {
      content: "";
      background: rgb(236 236 236 / 50%);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 6px;
    }
  }
  &.with-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .info-icon {
    cursor: pointer;
    margin-right: 0px;
    font-size: 18px;
    border: 2px solid;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    padding: 4px;
  }
  .validation {
    font-size: 16px;
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
  }
  .spinner {
    font-size: 16px;
    position: absolute;
    top: 35%;
    right: 16px;
    transform: translateY(-50%);
  }
`;
export const InputComponent = styled.input`
  position: relative;
  width: 100%;
  height: 44px;
  padding: 2px 16px;
  font-size: 14px;
  border: 2px solid ${inputBorderColor};
  border-radius: 6px;
  color: ${labelColor};
  box-shadow: none;
  outline: none;
  background-color: ${inputBackgroundColor};
  -webkit-appearance: none;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  font-style: normal;
  font-weight: normal;
  line-height: 26px;
  letter-spacing: 0.03em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &.with-info {
    width: calc(100% - 34px);
  }
  &.mb-0{
    margin-bottom: 0;
  }
  :disabled {
    pointer-events: none;
    background: #f7f7f7;
    color: #33403e;
  }
  @media (${screenSize.tablet}) {
    font-size: 14px;
    /* background-color: ${inputBackgroundColor};
    border-color: ${inputBorderColor}; */
    &:hover {
      background-color: ${inputBackgroundHoverColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }
  &.valid {
    border-color: ${successColor};
  }
  &.failed-validation {
    border-color: ${dangerColor};
  }
`;

export const Label = styled.label`
  display: block;
  font-family: "Filson";
  font-size: 14px;
  letter-spacing: 0.03em;
  color: ${labelColor};
  ${mediumFont};
  line-height: 1.25;
  margin-bottom: 4px;
  &.hide {
    display: none;
  };
  &.password-label{
    font-size: 16px;
    color: green;
    margin-top: 10px;
    font-weight: bold;
  };
`;

export const PopoverLeft = styled.div`
  position: absolute;
  right: 40px;
  background: #fff;
  line-height: 20px;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #01dfe5;
  font-size: 12px;
`;

export const Error = styled.span`
  display: block;
  font-size: 12px;
  ${mediumFont};
  color: ${dangerColor};
  margin: 4px 0 0;
`;

export const Instructions = styled.div`
display: flex;
margin-top: 6px;
.info-icon{
  margin-top: 2px;
  margin-right: 6px;
}
p{
  flex: 1;
  line-height: 1.35;
  font-size: 14px;
  margin: 0;
  opacity: 0.65;
}
&.danger{
  color: ${dangerColor};
  svg path{
    fill: ${dangerColor}
  }
}
`